/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2023 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

"use client";
import { Divider, Flex, View, Text, Heading, Menu, MenuTrigger, ActionButton, Item } from "@adobe/react-spectrum";
import Image from "next/image";

import style from './profile-panel.module.scss'
import { useEffect, useState } from "react";
import MoreIcon from '@spectrum-icons/workflow/More';
import { usePathname, useRouter } from "next/navigation";
import ChevronLeft from "@spectrum-icons/workflow/ChevronLeft";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { doEncryption } from "@/utils/encryption";
// import { doEncryption } from "@/utils/encryption";
// const themis = require('jsthemis');
// import SecureCellSeal from 'jsthemis';
// import { themis } from 
// import * as Themis from 'jsthemis';

export default function ProfilePanel({ data }) {
    const t = useTranslations("");
    const router = useRouter();
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [city, setCity] = useState("");
    const [country, setCountry] = useState("");
    const pathUrl = usePathname();
    const parts = pathUrl.split('/');
    const locale = parts[1];
    const handleReportAbuse = () => {
        router.push(`/${locale}/abuse/${data.id}`);
    }
    let encryptedGuid = null;
    if (data?._embedded?.owner?.id) {
        encryptedGuid = doEncryption(data?._embedded?.owner?.id);
    }
    

    // Themis.initialize({
    //     // Path to Themis Core library (required)
    //     themisPath: '/path/to/themis',
    //   });


    // const scellPW = SecureCellSeal.withPassphrase("PSXPASSTHROUGH");
    // const [encryptedGuid, setEncryptedGuid] = useState("");
    // const decoder = new TextDecoder('utf-8');

    const handleBackButtonPress = () => {
        router.back(); 
    }

    useEffect(() => {
        setFirstName(data._embedded.owner.first_name);
        setLastName(data._embedded.owner.last_name);
        setCity(data._embedded.owner.location);
        setCountry(data._embedded.owner.country);
        // doEncryption();
        // setEncryptedGuid(decoder.decode(scellPW.encrypt(Buffer.from(data?._embedded?.owner?.id, 'utf-8'))));
    }, [data._embedded.owner.first_name, data._embedded.owner.last_name, data._embedded.owner.country, data._embedded.owner.location])

    return (
        <View UNSAFE_className={style.outerDiv}>
            <View UNSAFE_className={style.innerDiv}>
                <Flex height={'size-1200'} alignItems={'center'} justifyContent={'space-between'}>
                    <Flex gap={10} alignItems={'center'}>
                        <View isHidden={{ L: true }}>
                        <ActionButton 
                            onPress={handleBackButtonPress} 
                            isQuiet 
                            staticColor="black" 
                            UNSAFE_className={style.backBtn}
                            >
                            <ChevronLeft size="S" /> 
                        </ActionButton>
                        </View>
                        <Link href={`/${locale}/user/${encryptedGuid}`} className={style.link}>
                        <div className={style.profile}>
                            <Image width={40} height={40} alt="Profile image" src={data._embedded.owner._links.images[5]?.href} loading="eager" />
                        </div>
                        </Link>
                        <Flex direction={'column'}>
                            {(firstName || lastName) && <Heading level={4}>
                                {firstName} {lastName}
                            </Heading>}
                            {
                                (country || city) && <Text>
                                    {city} {city && ','} {country}
                                </Text>
                            }
                        </Flex>
                    </Flex>
                    <MenuTrigger>
                        <ActionButton isQuiet>
                            <MoreIcon />
                        </ActionButton>
                        <Menu onAction={handleReportAbuse}>
                            <Item key="report">{t("report")}</Item>
                        </Menu>
                    </MenuTrigger>
                </Flex>
            </View>
            <Divider size="S" isHidden={{ base: true, L: false }} />
        </View>
    );
}